import { useState, useEffect } from 'react';
import { Collapse, UncontrolledCollapse, Button, CardBody, Card } from 'reactstrap'
import Lazyload from 'react-lazy-load'
import Testimonials from "./TestimonialsHome";
import AOS from "aos";
import "aos/dist/aos.css";
// import VisibilitySensor from "react-visibility-sensor";
// import { useElementOnScreen } from "../../hooks/useElementOnScreen";
import {Trans, useTranslation, useI18next} from 'gatsby-plugin-react-i18next';
import { useLocation } from '@reach/router';

const StepsChallenge = () => {
    const location = useLocation();
    const { pathname } = location;
    const { t } = useTranslation();
    useEffect(() => {
        AOS.init({
            duration: 2000,
            easing: 'ease-in-out-back',
            disable: 'mobile'
        });
    }, []);
    return (
    <>
        <section className="bg-dark multi-activity hero-bg position-relative section-pdn pt-8 soln-hero sc-1">
            <div className="container custom_container d-flex justify-content-start align-items-center p0 m-d-block">
                <div className="col-12">
                    <h1 className="font-weight-semibold hero-heading text-center" data-aos="fade-up" data-aos-once="true" data-aos-delay="50">
                        <Trans>Step Up Your Wellness</Trans>
                    {/* <br/> <span className="h1-sub">The Ultimate Steps Challenge!</span> */}
                    </h1>
                    <p className="hero-para font-weight-normal text-center no-br" data-aos="fade-up" data-aos-once="true" data-aos-delay="120">
                        <Trans>Promote physical activity and boost employee engagement <br/>with step-tracking challenges.</Trans>
                    </p>
                    <div className="pl-0 pr-0 col-12 mtb25 d-flex justify-content-center align-items-center" data-aos="fade-up" data-aos-once="true" data-aos-delay="200">
                        <a href={t(`/request-demo/`)} className="vfitcompanycta arrowbtn-img">
                            <Trans>Book a Demo</Trans>
                        </a>
                    </div>
                </div>
            </div>
        </section>
        <section className="position-relative pb-0 vfitsoln sc-2">
            <div className="feat_box feat_pb0 mb-0">
                <div className="d-flex m-d-block justify-content-between align-items-center container custom_container p0">
                    <div className="col-12 col-md-5 p-0">
                        <div className="col-12 p-0">
                            <h2 className='font-weight-semibold py-2 section-heading green-text' data-aos="fade-right" data-aos-once="true"><Trans>Struggling to keep your employees <span>physically active</span>?</Trans></h2>
                            <p className='section-para font-weight-normal no-br' data-aos="fade-right" data-aos-once="true"><Trans>Our Steps Challenge incentivizes regular movement <br/>and breaks, keeping them physically active.</Trans></p>
                        </div>
                    </div>
                    <div className='cta-img'>
                        <div className='d-flex floatimg'>
                            <img data-aos="fade-up-left" data-aos-once="true" data-aos-easing="ease-in-out-cubic" loading="lazy" src={t(`https://res.cloudinary.com/vantagecircle/image/upload/v1698664122/VantageFit/2023/Step-Challenge-Painpoint.webp`)} alt="Struggling to keep your employees active during work hours?" width="1001" height="1004"/>
                        </div>
                    </div>
                </div>
            </div>
        </section>

        <section className="position-relative pl-0 pr-0">
            <div className="">
                <h2 className="section-heading section-heading-top font-weight-semibold text-center no-br px-6"><Trans>Empowering Every Step Towards Wellness</Trans></h2>
                <div className="">
                    <div className="feat_box sect-white-col-2 shadow active_challenge">
                        <div className="container custom_container d-flex m-d-block p-0 justify-content-between align-items-center">
                            <div className="col-12 col-md-5">
                                <div className="col-12">
                                    <h2 className='font-weight-semibold py-2 section-heading'><Trans>Types of Step Challenges</Trans></h2>
                                    <p className='section-para font-weight-normal'><Trans>Pick the type of step challenge that meets your goals.</Trans></p>

                                    {/* THERE IS AN ISSUE WHERE THE TICK IS NOT APPEARING FOR ANYTHING OTHER THAN THE FIRST ITEM SO I HAD TO MAKE MULTIPLE ULs */}
                                    <div>
                                        <ul className='greenTick position-relative' style={{minHeight: '29px', marginTop: '2.5rem', marginBottom: '2.5rem' }}>
                                        <p className='text-white'><Trans>Race</Trans></p>
                                        </ul>
                                        <ul className='greenTick position-relative' style={{ minHeight: '29px', marginTop: '2.5rem', marginBottom: '2.5rem' }}>
                                            <p className='text-white'><Trans>Streak</Trans></p>
                                        </ul>
                                        <ul className='greenTick position-relative' style={{ minHeight: '29px', marginTop: '2.5rem', marginBottom: '2.5rem' }}>
                                            <p className='text-white'><Trans>E-marathon</Trans></p>
                                        </ul>
                                        <ul className='greenTick position-relative' style={{ minHeight: '29px', marginTop: '2.5rem', marginBottom: '2.5rem' }}>
                                            <p className='text-white'><Trans>Journey</Trans></p>
                                        </ul>
                                    </div>

                                </div>
                            </div>
                            <div className='col-12 col-md-7 cta-img'>
                                <div className='d-flex justify-content-center'>
                                    <img className="img-responsive" src={t(`https://res.cloudinary.com/vantagecircle/image/upload/v1698664124/VantageFit/2023/Step-Challenge-Types_of_Step_Challenges.webp`)} loading='lazy' alt="Wellness Challenges" width="751" height="910"/>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="feat_box sect-white-col-2 shadow active_challenge">
                        <div className="container custom_container d-flex m-d-block p-0 justify-content-between align-items-center">
                            <div className="col-12 col-md-5">
                                <div className="col-12">
                                    <h2 className='font-weight-semibold py-2 section-heading'><Trans>Real-time Leaderboards</Trans></h2>
                                    {/* <p className='section-para font-weight-normal'>Boost competition with live leaderboards. Celebrate top steppers.</p> */}
                                    <div>
                                        <ul className='greenTick position-relative' style={{minHeight: '29px', marginTop: '2.5rem', marginBottom: '2.5rem' }}>
                                        <p className='text-white'><Trans>Encourage competition through real-time leaderboards.</Trans></p>
                                        </ul>
                                        <ul className='greenTick position-relative' style={{ minHeight: '29px', marginTop: '2.5rem', marginBottom: '2.5rem' }}>
                                            <p className='text-white'><Trans>Celebrate and acknowledge top performers instantly.</Trans></p>
                                        </ul>
                                        <ul className='greenTick position-relative' style={{ minHeight: '29px', marginTop: '2.5rem', marginBottom: '2.5rem' }}>
                                            <p className='text-white'><Trans>Keep employees engaged and motivated with dynamic and live updates.</Trans></p>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                            <div className='col-12 col-md-7 cta-img'>
                                <div className='d-flex justify-content-center'>
                                    <img className="img-responsive" src={t(`https://res.cloudinary.com/vantagecircle/image/upload/v1698664123/VantageFit/2023/Step-Challenge-Real_time_leaderboard.webp`)} loading='lazy' alt="Wellness Challenges" width="751" height="1014"/>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="feat_box sect-white-col-2 shadow active_challenge">
                        <div className="container custom_container d-flex m-d-block p-0 justify-content-between align-items-center">
                            <div className="col-12 col-md-5">
                                <div className="col-12">
                                    <h2 className='font-weight-semibold py-2 section-heading no-br'><Trans>Rewards & <br/>Recognition</Trans></h2>
                                    {/* <p className='section-para font-weight-normal'>Boost competition with live leaderboards.<br/>Honor milestones and efforts to enhance motivation with our Vantage Fit points.</p> */}
                                    <div>
                                        <ul className='greenTick position-relative' style={{minHeight: '29px', marginTop: '2.5rem', marginBottom: '2.5rem' }}>
                                        <p className='text-white'><Trans>Acknowledge and celebrate fitness milestones and efforts.</Trans></p>
                                        </ul>
                                        <ul className='greenTick position-relative' style={{ minHeight: '29px', marginTop: '2.5rem', marginBottom: '2.5rem' }}>
                                            <p className='text-white'><Trans>Boost motivation by rewarding achievements with Vantage Fit points.</Trans></p>
                                        </ul>
                                        <ul className='greenTick position-relative' style={{ minHeight: '29px', marginTop: '2.5rem', marginBottom: '2.5rem' }}>
                                            <p className='text-white'><Trans>Encourage continuous engagement and progress with a recognition system.</Trans></p>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                            <div className='col-12 col-md-7 cta-img'>
                                <div className='d-flex justify-content-center'>
                                    <img className="img-responsive" src={t(`https://res.cloudinary.com/vantagecircle/image/upload/v1703068666/VantageFit/2023/Step-Challenge-Rewards_Recognition.webp`)} loading='lazy' alt="Wellness Challenges" width="529" height="600"/>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="feat_box sect-white-col-2 shadow active_challenge">
                        <div className="container custom_container d-flex m-d-block p-0 justify-content-between align-items-center">
                            <div className="col-12 col-md-5">
                                <div className="col-12">
                                    <h2 className='font-weight-semibold py-2 section-heading no-br'><Trans>Everything <br/>Counts</Trans></h2>
                                    {/* <p className='section-para font-weight-normal'>Whether someone walks, jogs, or dances, every step counts!</p> */}
                                    <div>
                                        <ul className='greenTick position-relative' style={{minHeight: '29px', marginTop: '2.5rem', marginBottom: '2.5rem' }}>
                                            <p className='text-white'><Trans>Every step, whether walking, jogging, or dancing, contributes to progress.</Trans></p>
                                        </ul>
                                        <ul className='greenTick position-relative' style={{ minHeight: '29px', marginTop: '2.5rem', marginBottom: '2.5rem' }}>
                                            <p className='text-white'><Trans>All types of physical activity are included – every effort matters!</Trans></p>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                            <div className='col-12 col-md-7 cta-img'>
                                <div className='d-flex justify-content-center'>
                                    <img className="img-responsive" src={t(`https://res.cloudinary.com/vantagecircle/image/upload/v1703068586/VantageFit/2023/Step-Challenge-Everything_Counts.webp`)} loading='lazy' alt="Wellness Challenges" width="497" height="600" />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
        <section className="gray-gradient-bg section-pdn-1">
            <div className="container custom_container mx-auto relative">
                <div className="px-5">
                    <h2 className="section-heading text-center pt-0">
                    <Trans>Real people, real results</Trans>
                    </h2>
                    <p className="col-12 sub-para text-center f-400 mt-0 mb-5 pb-5">
                    <Trans>Vantage Fit speaks for itself, but our customer reviews speak even louder.</Trans>
                    </p>
                    {/* <div className="col-lg-12 testimonialcarousel mb-0 p-5">
                        <div className="testi_profile">
                            <div className="testi_profile_image"><img src="https://res.cloudinary.com/vantagecircle/image/upload/v1700204240/VantageFit/2023/Pyry_Liukkonen.webp" alt="Coach Pyry" className="max-w lozad" width="218" height="218" loading="lazy"/></div>
                            <div className="testi_profile_name p-4">
                                <h3 className="font-weight-bold text-center text-lg-left text-white mb-0">Pyry Liukkonen</h3>
                                <p className="font-weight-light text-center text-lg-left text-white mb-0">Coach Pyry</p>
                            </div>
                        </div>
                        <div className="d-flex flex-column flex-lg-row justify-content-around align-items-center ">
                            <div className="col-12 col-md-11 d-flex flex-column">
                                <p className="section-para text-center text-lg-left mb-0">I've seen a significant increase in engagement and participation due to the step challenges.</p>
                            </div>
                        </div>
                    </div> */}
                    <div className="col-lg-12 testimonialcarousel d-none d-md-flex mb-0 p-5">
                        <div className="testi_profile">
                            <div className="testi_profile_image"><img src="https://res.cloudinary.com/vantagecircle/image/upload/v1700218240/VantageFit/2023/Pyry_Liukkonen.webp" alt="Coach Pyry" className="max-w lozad" width="218" height="218" loading="lazy"/></div>
                                <div className="testi_profile_name p-4">
                                    <h3 className="font-weight-bold text-center text-lg-left text-white mb-0">Pyry Liukkonen</h3>
                                    <p className="font-weight-light text-center text-lg-left text-white mb-0">Coach Pyry</p>
                                </div>
                            </div>
                            <div className="d-flex flex-column flex-lg-row justify-content-around align-items-center ">
                                <div className="col-12 col-md-11 d-flex flex-column">
                                    <p className="section-para text-center text-lg-left mb-0"><Trans>I've seen a significant increase in engagement and participation due to the step challenges.</Trans></p>
                                </div>
                            </div>
                        </div>
                        <div className="d-md-none d-block p-3" style={{ background: 'white', boxShadow: '1px 0px 20px rgba(0,0,0,0.3)', borderRadius: '25px' }}>
                            <div className="p-2" style={{ background: '#1d2227', borderRadius: '40px', display: 'grid', justifyContent: 'center' }}>
                                <img style={{ marginLeft: '0.5rem !important', marginTop: '0.5rem', marginBottom: '1rem' }} src="https://res.cloudinary.com/vantagecircle/image/upload/v1700218240/VantageFit/2023/Pyry_Liukkonen.webp" alt="Coach Pyry" className="mx-auto" width="218" height="218" loading="lazy"/>
                                <h3 className="font-weight-bold text-center text-white mb-0">Pyry Liukkonen</h3>
                                <p className="font-weight-light text-center text-white my-3">Coach Pyry</p>
                            </div>
                            <p className="section-para text-center text-lg-left my-4"><Trans>I've seen a significant increase in engagement and participation due to the step challenges.</Trans></p>

                        </div>
                    </div>
            </div>
        </section>
        <section className="position-relative section-pdn-1 pl-0 pr-0 faq-wrapper">
            <div className="logo-container">
                <h2 className="section-heading mb-5 no-br clr49 font-weight-bold">FAQ</h2>
                <div id="accordion" className="">
                    <Card>
                        <Button id="faq1">
                            <Trans>How do employees track their steps?</Trans>
                        </Button>
                        <UncontrolledCollapse toggler="#faq1">
                            <CardBody>
                                <Trans>Vantage Fit includes an Activity Tracker that automatically records each step taken by the user. These steps are seamlessly monitored and logged in through Google Fit when the device is synchronized with it.</Trans>
                            </CardBody>
                        </UncontrolledCollapse>
                    </Card>
                    <Card>
                        <Button id="faq2">
                            <Trans>Can the challenge be customized for remote teams?</Trans>
                        </Button>
                        <UncontrolledCollapse toggler="#faq2">
                            <CardBody>
                            <Trans>Yes, challenges can be customized for remote teams.</Trans>
                            </CardBody>
                        </UncontrolledCollapse>
                    </Card>
                    <Card>
                        <Button id="faq3">
                            <Trans>How do we reward and motivate the users for greater efforts?</Trans>
                        </Button>
                        <UncontrolledCollapse toggler="#faq3">
                            <CardBody>
                                <Trans>Vantage Fit provides users with a variety of gift card options that they can redeem using the Vantage Points they've earned through their wellness efforts. Additionally, Vantage Fit acknowledges and appreciates users' commitment to a healthier lifestyle by awarding them badges and certificates as recognition for their wellness achievements.</Trans>
                            </CardBody>
                        </UncontrolledCollapse>
                    </Card>
                </div>
            </div>
        </section>
        <section className="sc-btm ctabtm multi-activity hero-bg position-relative section-pdn-1 pt-8 feat_testi brad0">
            <div className="container custom_container d-flex justify-content-start align-items-center p0 m-d-block">
                <div className="col-12">
                    <h2 className="font-weight-semibold section-heading text-center">
                    <Trans>Ready to Step Up Your Wellness Game?</Trans>
                    </h2>
                    <p className="sub-para font-weight-normal text-center mb-5">
                    <Trans>Join companies worldwide benefiting from our Step Challenge.</Trans>
                    </p>
                    <div className="pl-0 pr-0 col-12 mt-4 d-flex justify-content-center align-items-center">
                        <a href={t(`/request-demo/`)} className="vfitcompanycta arrowbtn-img">
                            <Trans>Book a Demo</Trans>
                        </a>
                    </div>
                </div>
            </div>
        </section>

    </>
  )
}

export default StepsChallenge
